import React from 'react';

import { Icon } from '../icons';

export const PlusIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M30.6666667,13.3333333 L18.6666667,13.3333333 L18.6666667,1.33333333 C18.6666667,0.596666667 18.07,0 17.3333333,0 L14.6666667,0 C13.93,0 13.3333333,0.596666667 13.3333333,1.33333333 L13.3333333,13.3333333 L1.33333333,13.3333333 C0.596666667,13.3333333 0,13.93 0,14.6666667 L0,17.3333333 C0,18.07 0.596666667,18.6666667 1.33333333,18.6666667 L13.3333333,18.6666667 L13.3333333,30.6666667 C13.3333333,31.4033333 13.93,32 14.6666667,32 L17.3333333,32 C18.07,32 18.6666667,31.4033333 18.6666667,30.6666667 L18.6666667,18.6666667 L30.6666667,18.6666667 C31.4033333,18.6666667 32,18.07 32,17.3333333 L32,14.6666667 C32,13.93 31.4033333,13.3333333 30.6666667,13.3333333 Z" />
    </svg>
  );
};
